import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Dashboard from './Dashboard';
import StickerMap from './StickerMap';
import Stickers from './Stickers';
import stickerStore from '../stores/StickerStore';
import StickerDetails from './StickerDetails';
import Clients from './Clients';
import ClientDetails from './ClientDetails';
import clientStore from '../stores/ClientStore';
import Orders from './Orders';
import OrderDetails from './OrderDetails';
import orderStore from '../stores/OrderStore';
import Products from './Products';
import ProductDetails from './ProductDetails';
import ProductLandingpage from './ProductLandingpage';
import ProductBlankPage from './ProductBlankPage';
import productStore from '../stores/ProductStore';
import Users from './Users';
import UserDetails from './UserDetails';
import userStore from '../stores/UserStore';
import statStore from '../stores/StatStore';
import Terms from './Terms';
import TermsDetails from './TermsDetails';
import termsStore from '../stores/TermsStore';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  }
});

class Main extends Component {
  constructor(props) {
    super(props);
    this._validAuthStates = ['signedIn'];
  }

  render() {
    const { classes } = this.props;
   
    return (
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <Switch>
          <Route exact path="/" render={(props) =>  <Redirect to='/dashboard' {...props} /> } />
          <Route exact path="/dashboard" render={(props) => <Dashboard {...props} statStore={statStore} />} />
          <Route exact path="/map" render={(props) => <StickerMap {...props} stickerStore={stickerStore} />} />
          <Route exact path="/stickers" render={(props) => <Stickers {...props} stickerStore={stickerStore} />} />
          <Route exact path="/stickers/:id" render={(props) => <StickerDetails {...props} stickerStore={stickerStore} />} />
          <Route exact path="/clients" render={(props) => <Clients {...props} clientStore={clientStore} />} />
          <Route exact path="/clients/:id" render={(props) => <ClientDetails {...props} clientStore={clientStore} />} />
          <Route exact path="/orders" render={(props) => <Orders {...props} orderStore={orderStore} />} />
          <Route exact path="/orders/:id" render={(props) => <OrderDetails {...props} orderStore={orderStore} />} />
          <Route exact path="/products" render={(props) => <Products {...props} productStore={productStore} />} />
          <Route exact path="/products/:id" render={(props) => <ProductDetails {...props} productStore={productStore} />} />
          <Route exact path="/products/:id/landingpage" render={(props) => <ProductLandingpage {...props} productStore={productStore} />} />
          <Route exact path="/products/:id/blankpage" render={(props) => <ProductBlankPage {...props} productStore={productStore} />} />
          <Route exact path="/users" render={(props) => <Users {...props} userStore={userStore} />} />
          <Route exact path="/users/:id" render={(props) => <UserDetails {...props} userStore={userStore} stickerStore={stickerStore} />} />
          <Route exact path="/terms" render={(props) => <Terms {...props} termsStore={termsStore} />} />
          <Route exact path="/terms/:id" render={(props) => <TermsDetails {...props} termsStore={termsStore}  />} />
        </Switch>
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Main);